var observer = lozad('.lozad', {
  // rootMargin: '100px 0px', // like css margin
  // threshold: 0.1 // ratio of element convergence
  loaded: function(el) {
    // Custom implementation on a loaded element
    el.classList.add('loaded');
  }
});
observer.observe();
